import React from 'react'

export default function TeamMeet() {
  return (
    <>
      <section className='team-meet'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-9'>
              <div className='team-meet-area'>
                <h2 className='heading center-heading'>Meet the team</h2>
                <p className='sub-heading'>Our experts bring deep industry knowledge and a customer-first approach—ensuring reliable, secure, efficient information management solutions, every step of the way.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}
